import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { InstructionsForUseProperties } from './instructions-for-use-types.js';
class InstructionsForUseAPI extends ComponentAPI {
    /**
     * Obtains the logo icon.
     */
    getLogoIcon() {
        return this.state.logoIcon ?? InstructionsForUseProperties.logoIcon.defaultValue;
    }
    /**
    * Sets the logo icon.
    *
    * @param logoIcon - The logo icon.
    */
    setLogoIcon(logoIcon) {
        this.setState({ logoIcon });
    }
    /**
     * Obtains the product name.
     */
    getProductName() {
        return this.state.productName;
    }
    /**
     * Updates the product name.
     *
     * @param productName - The product name.
     */
    setProductName(productName) {
        this.setState({ productName });
    }
    /**
     * Obtains the instructions for use.
     */
    getInstructionsForUse() {
        return this.state.instructionsForUse;
    }
    /**
     * Updates the instructions for use, accepting rich text content.
     *
     * @param instructionsForUse - The instructions for use.
     */
    setInstructionsForUse(instructionsForUse) {
        this.setState({ instructionsForUse });
    }
}
export { InstructionsForUseAPI, };
//# sourceMappingURL=instructions-for-use-api.js.map